import { CheckOutlined, CloseOutlined, HourglassOutlined } from '@ant-design/icons';
import { Modal, Table, Tooltip } from 'antd';
import "bootstrap-icons/font/bootstrap-icons.css";
import jwtDecode from "jwt-decode";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { loadAllLinkUser, updateLinkUser } from "../../redux/rtk/features/linkUser/linkUserSlice";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";


function CustomTable({ total }) {
    const [status, setStatus] = useState("true");
    const [columnsToShow, setColumnsToShow] = useState([]);

    let userTblList = useSelector((state) => state.linkUser.list || []);
    const dispatch = useDispatch();


    const handleAccept = (record) => {
        Modal.confirm({
            title: 'Confirm Accept',
            content: 'Are you sure you want to accept?',
            onOk() {
                dispatch(updateLinkUser({
                    id: record.userCompanyLinkId,
                    values: {
                        acceptByUser: 1,
                        userId: record.userId,
                        companyId: record.companyId,
                        acceptByCompany: record.acceptByCompany
                    }
                })).then(() => {
                    // Refresh table after successful update
                    dispatch(loadAllLinkUser(record.userId));
                });
                console.log('Accept clicked for record:', record);
            },
        });
    };
    
    const handleReject = (record) => {
        Modal.confirm({
            title: 'Confirm Reject',
            content: 'Are you sure you want to reject?',
            onOk() {
                dispatch(updateLinkUser({
                    id: record.userCompanyLinkId,
                    values: {
                        acceptByUser: 2,
                        userId: record.userId,
                        companyId: record.companyId,
                        acceptByCompany: record.acceptByCompany
                    }
                })).then(() => {
                    // Refresh table after successful update
                    dispatch(loadAllLinkUser(record.userId));
                });
                console.log('Reject clicked for record:', record);
            },
        });
    };

    const handleCancelRequest = (record) => {
        // Logic for cancel button (if needed)
        console.log('Cancel clicked for record:', record);
    };

    const handleLeaveCompany = (record) => {
        // Logic for leave company button (if needed)
        console.log('Leave Company clicked for record:', record);
    };

    const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));

    const columns = [
        {
            id: 0,
            title: "S.No.",
            dataIndex: "serial",
            key: "serial",
        },
   
        {
            id: 4,
            title: "Company",
            dataIndex: "companyMaster",
            key: "companyMaster",
            render: (company) => company?.company_name,
        },
        {
            id: 5,
            title: "Accept By User",
            dataIndex: "acceptByUser",
            key: "acceptByUser",
            render: (acceptByUser) => {
                if (acceptByUser === 1) {
                    return (
                        <Tooltip title="Accepted">
                            <CheckOutlined style={{ color: 'green' }} />
                        </Tooltip>
                    );
                } else if (acceptByUser === 2) {
                    return (
                        <Tooltip title="Rejected">
                            <CloseOutlined style={{ color: 'red' }} />
                        </Tooltip>
                    );
                } else if (acceptByUser === 0) {
                    return (
                        <Tooltip title="Pending">
                            <HourglassOutlined style={{ color: 'orange' }} />
                        </Tooltip>
                    );
                }
            },
        },
        {
            id: 6,
            title: "Accept By Company",
            dataIndex: "acceptByCompany",
            key: "acceptByCompany",
            render: (acceptByCompany) => {
                if (acceptByCompany === 1) {
                    return (
                        <Tooltip title="Accepted">
                            <CheckOutlined style={{ color: 'green' }} />
                        </Tooltip>
                    );
                } else if (acceptByCompany === 2) {
                    return (
                        <Tooltip title="Rejected">
                            <CloseOutlined style={{ color: 'red' }} />
                        </Tooltip>
                    );
                } else if (acceptByCompany === 0) {
                    return (
                        <Tooltip title="Pending">
                            <HourglassOutlined style={{ color: 'orange' }} />
                        </Tooltip>
                    );
                }
            },
        },
        {
            id: 7,
            title: "Cancel Request By User",
            dataIndex: "cancelRequestByUser",
            key: "cancelRequestByUser",
        },
        {
            id: 8,
            title: "Cancel Request By Company",
            dataIndex: "cancelRequestByCompany",
            key: "cancelRequestByCompany",
        },
        {
            id: 9,
            title: "Action",
            align: "center",
            render: (record) => {
                const { acceptByUser, acceptByCompany } = record;

                if (acceptByUser === 2 || acceptByCompany === 2) {
                    return null;
                }

                if (acceptByUser === 1 && acceptByCompany === 1) {
                    return (
                        <button
                            onClick={() => handleLeaveCompany(record)}
                            style={{
                                padding: '8px 16px',
                                marginRight: '8px',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                backgroundColor: '#0000FF',
                                color: 'white'
                            }}
                        >
                            Leave Company
                        </button>
                    );
                }

                if (acceptByCompany === 1) {
                    return (
                        <>
                            <button
                                onClick={() => handleAccept(record)}
                                style={{
                                    padding: '8px 16px',
                                    marginRight: '8px',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    backgroundColor: '#4CAF50',
                                    color: 'white'
                                }}
                            >
                                Accept
                            </button>
                            <button
                                onClick={() => handleReject(record)}
                                style={{
                                    padding: '8px 16px',
                                    marginRight: '8px',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    backgroundColor: '#f44336',
                                    color: 'white'
                                }}
                            >
                                Reject
                            </button>
                        </>
                    );
                }

                if (acceptByUser === 1) {
                    return (
                        <button
                            onClick={() => handleCancelRequest(record)}
                            style={{
                                padding: '8px 16px',
                                marginRight: '8px',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                backgroundColor: '#FFA500',
                                color: 'white'
                            }}
                        >
                            Cancel Request
                        </button>
                    );
                }

                return null;
            },
        }
    ];

    useEffect(() => {
        setColumnsToShow(columns);
    }, []);

    const columnsToShowHandler = (val) => {
        setColumnsToShow(val);
    };

    return (
        <div className='ant-card p-4 rounded mt-5'>
            <div className='flex my-2 justify-between'>
                <div className='w-50'>
                    <h4 className='text-2xl mb-2'> Request List</h4>
                </div>
                {userTblList && (
                    <div className='flex justify-end mr-4'>
                    </div>
                )}
            </div>
            {userTblList && (
                <div style={{ marginBottom: "30px" }}>
                    <ColVisibilityDropdown
                        options={columns}
                        columns={columns}
                        columnsToShowHandler={columnsToShowHandler}
                    />
                </div>
            )}
            <Table
                className='text-center'
                scroll={{ x: true }}
                loading={!userTblList}
                
                columns={columnsToShow}
                dataSource={userTblList ? addKeys(userTblList) : []}
            />
        </div>
    );
}

const LinkUserTblData = (props) => {
    const dispatch = useDispatch();
    let userTblList = useSelector((state) => state.linkUser.list || []);
    const total = useSelector((state) => state.linkUser.total);
    const token = localStorage.getItem("access-token");
    const userId = jwtDecode(token).sub;

    useEffect(() => {
        dispatch(loadAllLinkUser(userId));
    }, []);
    return (
            <div className='card-body'>
                <CustomTable list={userTblList} total={total} />
            </div>
    );
};

export default LinkUserTblData;
